import { render, staticRenderFns } from "./OrderPriceModule.vue?vue&type=template&id=64ca70c6"
import script from "./OrderPriceModule.vue?vue&type=script&lang=js"
export * from "./OrderPriceModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports